export default "__VITE_ASSET__DtiAm5IU__"